<div
  #gmap
  class="google-map"
  data-cy="drp-results-map"
  [ngClass]="{
    defaultSize: searchContext === contextValues.DRP_SHOP_SEARCH,
    shortenedSize: searchContext !== contextValues.DRP_SHOP_SEARCH,
    mapLoaded: mapLoaded
  }"
></div>
